import { Navigate, Outlet } from 'react-router-dom';

export const ProtectedRoute = ({ redirectPath = '/' }) => {
    const sessionToken = localStorage.getItem('token');

    if (!sessionToken) {
        return <Navigate to={redirectPath} replace />;
    }

    return (
        // <PageContainer>
        <>
            <div style={{display: 'flex', flexDirection: 'row'}}>
            <Outlet />
            </div>
        </>
        // </PageContainer>
    )
}